export enum DocumentArchiveTab {
  Board = 'tab1',
  Bbl = 'tab2',
  Prosjektarkiv = 'tab3',
}

export enum DocumentArchiveVariant {
  Board = 'board',
  Bbl = 'bbl',
  Prosjektarkiv = 'prosjektarkiv',
}
